import { type UseQueryResult, useQuery } from 'react-query';
import {
  PagedResultDto_ExportTransferAllocateDto,
  TransferAllocateService,
} from '@wealthlane/api-services/wealthlane-award-service';
import { ParticipantBankJobService } from '@wealthlane/api-services/wealthlane-finance-integration-service';

const useGetParticipantBankList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: any
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_ExportTransferAllocateDto | undefined,
  unknown
> => {
  const { status, companyId, filter, sorting, skipCount, maxResultCount, _force } = tableInfo;
  const getParticipantBankList = useQuery(
    [
      'getParticipantBankList',
      filter,
      status,
      companyId,
      sorting,
      maxResultCount,
      skipCount,
      _force,
    ],
    async () => {
      return await handleRequest(
        ParticipantBankJobService.getApiFinanceIntegrationApiAppParticipantBankJobParticipantBankListForVerification(
          [status],
          [companyId],
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return getParticipantBankList;
};

export default useGetParticipantBankList;
